import { UserAvailabilityOptions } from "@bezoned/shared/types/user-presence.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { PresenceAwayRegular } from "@fluentui/react-icons";

import { useMyPresence } from "../../../features/presence/use-my-presence.js";
import { useLayoutStore } from "../../../store/layout.store.js";
import { recordErrorInSentry } from "../../../utils/init-sentry.js";
import type { SharedModalProps } from "./base-modal.jsx";

export type InactivityWarningModalProps = SharedModalProps & {
  remainingMinutes: number;
};

export const InactivityWarningModal = ({
  remainingMinutes,
}: InactivityWarningModalProps) => {
  const { hideModal } = useLayoutStore();
  const { updateAvailability } = useMyPresence();

  const handleStayInOffice = () => {
    try {
      updateAvailability(UserAvailabilityOptions.Available);
      // ? We don't need to run ping, because it should be executed automatically when the status changes.
      hideModal();
    } catch (error) {
      recordErrorInSentry(error);
    }
  };

  return (
    <Dialog modalType="alert" open={true}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle className="flex items-center gap-2">
            <PresenceAwayRegular className="size-6" />
            Automatic Exit
          </DialogTitle>
          <DialogContent>
            <p>
              You have been away for a while and will automatically be exited
              from the office in{" "}
              <strong>
                {remainingMinutes < 1
                  ? "less than a minute"
                  : `${Math.round(remainingMinutes)} minutes`}
              </strong>
              .
            </p>
            <br />
            <p>Please click the button below to stay in the office.</p>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={handleStayInOffice}
              type="button"
            >
              Stay in office
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
